import { type Predicate } from "./predicate";

// biome-ignore lint/style/useConsistentArrayType :[AUTOMATICALLY-INSERTED] Use shorthand T[] syntax instead of Array<T> syntax.
export const allPass: <T>(predicates: [Predicate<T>, Predicate<T>, ...Array<Predicate<T>>]) => Predicate<T> =
  // biome-ignore lint/style/useConsistentArrayType :[AUTOMATICALLY-INSERTED] Use shorthand T[] syntax instead of Array<T> syntax.
    <T>(predicates: Array<Predicate<T>>) =>
    (x: T) =>
      predicates.reduce<boolean>((acc, predicate) => acc && predicate(x), true);

export const complement =
  <T>(predicate: Predicate<T>): Predicate<T> =>
  (x: T): boolean =>
    !predicate(x);
